/**
 * Serializer for College data
 */
class CollegeSerializer {
  /**
   * Transform backend API response to frontend format
   */
  fromJSON(apiData) {
    const college = apiData?.data || apiData;
    if (!college) return null;
    return {
      id: college.id,
      name: college.name || "",
      description: college.description || "",
      programId: college.programId || null,
      programCount: college.program_count || 0,
      programs: college.programs || [],
      createdAt: college.created_at || null,
      updatedAt: college.updated_at || null,
    };
  }

  /**
   * Transform frontend data to backend API format for create
   */
  toCreateJSON(frontendData) {
    return {
      name: frontendData.name || "",
      description: frontendData.description || "",
    };
  }

  /**
   * Transform frontend data to backend API format for update
   */
  toUpdateJSON(frontendData) {
    return this.toCreateJSON(frontendData);
  }

  /**
   * Serialize list of colleges
   */
  fromListJSON(apiDataList) {
    if (!apiDataList) return [];
    return apiDataList.map((college) => this.fromJSON(college));
  }
}

/**
 * Serializer for Program data
 */
class ProgramSerializer {
  /**
   * Transform backend API response to frontend format
   */
  fromJSON(apiData) {
    const program = apiData?.data || apiData;
    if (!program) return null;
    return {
      id: program.id,
      code: program.code || "",
      name: program.name || "",
      description: program.description || "",
      collegeId: program.college_id,
      college: program.college || null,
      createdAt: program.created_at || null,
      updatedAt: program.updated_at || null,
    };
  }

  /**
   * Transform frontend data to backend API format for create
   */
  toCreateJSON(frontendData) {
    return {
      name: frontendData.name || "",
      code: frontendData.code || "",
      description: frontendData.description || "",
      college_id: frontendData.collegeId,
    };
  }

  /**
   * Transform frontend data to backend API format for update
   */
  toUpdateJSON(frontendData) {
    return this.toCreateJSON(frontendData);
  }

  /**
   * Serialize list of programs
   */
  fromListJSON(apiDataList) {
    if (!apiDataList) return [];
    return apiDataList.map((program) => this.fromJSON(program));
  }
}

export const collegeSerializer = new CollegeSerializer();
export const programSerializer = new ProgramSerializer();
